import { makeStyles } from "@material-ui/core/styles";
import { Grid, Typography } from "@material-ui/core";
import { FieldSetBox } from "../../fieldSetBox";
import { ReportField } from "../reportField";
import { formatCurrencyField } from "../../../utils/utils";

const useStyles = makeStyles(() => ({
  longTextTypography: {
    fontSize: "14px",
    padding: "16px",
    paddingTop: "10px",
    fontWeight: 400,
  },
}));

interface ScopeOfWorkBoxProps {
  renovationBudget: number;
  completedRenovation: number;
  totalRenovationBudget: number;
  scopeOfWorkDescription: string;
}

export const ScopeOfWorkBox = ({ renovationBudget, completedRenovation, totalRenovationBudget, scopeOfWorkDescription }: ScopeOfWorkBoxProps) => {
  const classes = useStyles();

  return (<FieldSetBox title="Scope of Work">
    <Grid container>
      <Grid item xs={4}>
        <ReportField label="Renovation Budget" value={formatCurrencyField(renovationBudget)} />
      </Grid>
      <Grid item xs={4}>
        <ReportField label="CAP EX" value={formatCurrencyField(completedRenovation)} />
      </Grid>
      <Grid item xs={4}>
        <ReportField
          label="Total Renovation Budget"
          value={formatCurrencyField(totalRenovationBudget)}
          removeRightBorder
        />
      </Grid>
      <Grid item xs={12}>
        <ReportField label="Project Summary" removeRightBorder>
          <Typography className={classes.longTextTypography}>
            {scopeOfWorkDescription}
          </Typography>
        </ReportField>
      </Grid>
    </Grid>
  </FieldSetBox>);
}